import * as api from '../api/abstractSubdivision';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN';

export const FETCH_ABSTRACT_SUBDIVISIONS = createRequestTypes(
  `${prefix}/FETCH_ABSTRACT_SUBDIVISIONS`,
);

export const fetchAbstractSubdivisions = makeApiActionCreatorV3(
  api.fetchAbstractSubdivisions,
  FETCH_ABSTRACT_SUBDIVISIONS[START],
  FETCH_ABSTRACT_SUBDIVISIONS[SUCCESS],
  FETCH_ABSTRACT_SUBDIVISIONS[ERROR],
);

export const FETCH_ABSTRACT_SUBDIVISION_INDICATORS = createRequestTypes(
  `${prefix}/FETCH_ABSTRACT_SUBDIVISION_INDICATORS`,
);

export const fetchAbstractSubdivisionIndicators = makeApiActionCreatorV3(
  api.fetchAbstractSubdivisionIndicators,
  FETCH_ABSTRACT_SUBDIVISION_INDICATORS[START],
  FETCH_ABSTRACT_SUBDIVISION_INDICATORS[SUCCESS],
  FETCH_ABSTRACT_SUBDIVISION_INDICATORS[ERROR],
);

export const RESET_ABSTRACT_SUBDIVISIONS = `${prefix}/RESET_ABSTRACT_SUBDIVISIONS`;

export const resetAbstractSubdivisions = () => ({
  type: RESET_ABSTRACT_SUBDIVISIONS,
});

export const UPDATE_ABSTRACT_SUBDIVISION_DESCRIPTION = createRequestTypes(
  `${prefix}/UPDATE_ABSTRACT_SUBDIVISION_DESCRIPTION`,
);

export const updateAbstractSubdivisionDescription = makeApiActionCreatorV3(
  api.updateAbstractSubdivisionDescription,
  UPDATE_ABSTRACT_SUBDIVISION_DESCRIPTION[START],
  UPDATE_ABSTRACT_SUBDIVISION_DESCRIPTION[SUCCESS],
  UPDATE_ABSTRACT_SUBDIVISION_DESCRIPTION[ERROR],
);

export const INSERT_ABSTRACT_SUBDIVISION = createRequestTypes(
  `${prefix}/INSERT_ABSTRACT_SUBDIVISION`,
);

export const insertAbstractSubdivision = makeApiActionCreatorV3(
  api.insertAbstractSubdivision,
  INSERT_ABSTRACT_SUBDIVISION[START],
  INSERT_ABSTRACT_SUBDIVISION[SUCCESS],
  INSERT_ABSTRACT_SUBDIVISION[ERROR],
);

export const FETCH_ABSTRACT_SUBDIVISION = createRequestTypes(
  `${prefix}/FETCH_ABSTRACT_SUBDIVISION`,
);

export const fetchAbstractSubdivision = makeApiActionCreatorV3(
  api.fetchAbstractSubdivision,
  FETCH_ABSTRACT_SUBDIVISION[START],
  FETCH_ABSTRACT_SUBDIVISION[SUCCESS],
  FETCH_ABSTRACT_SUBDIVISION[ERROR],
);

export const RESET_ABSTRACT_SUBDIVISION = `${prefix}/RESET_ABSTRACT_SUBDIVISION`;

export const resetAbstractSubdivision = () => ({
  type: RESET_ABSTRACT_SUBDIVISION,
});

export const UPDATE_ABSTRACT_SUBDIVISION = createRequestTypes(
  `${prefix}/UPDATE_ABSTRACT_SUBDIVISION`,
);

export const updateAbstractSubdivision = makeApiActionCreatorV3(
  api.updateAbstractSubdivision,
  UPDATE_ABSTRACT_SUBDIVISION[START],
  UPDATE_ABSTRACT_SUBDIVISION[SUCCESS],
  UPDATE_ABSTRACT_SUBDIVISION[ERROR],
);

export const DELETE_ABSTRACT_SUBDIVISION = createRequestTypes(
  `${prefix}/DELETE_ABSTRACT_SUBDIVISION`,
);

export const deleteAbstractSubdivision = makeApiActionCreatorV3(
  api.deleteAbstractSubdivision,
  DELETE_ABSTRACT_SUBDIVISION[START],
  DELETE_ABSTRACT_SUBDIVISION[SUCCESS],
  DELETE_ABSTRACT_SUBDIVISION[ERROR],
);

export const FETCH_ABSTRACT_SUBDIVISION_PLATS = createRequestTypes(
  `${prefix}/FETCH_ABSTRACT_SUBDIVISION_PLATS`,
);

export const fetchAbstractSubdivisionPlats = makeApiActionCreatorV3(
  api.fetchAbstractSubdivisionPlats,
  FETCH_ABSTRACT_SUBDIVISION_PLATS[START],
  FETCH_ABSTRACT_SUBDIVISION_PLATS[SUCCESS],
  FETCH_ABSTRACT_SUBDIVISION_PLATS[ERROR],
);

export const INSERT_ABSTRACT_SUBDIVISION_FILE = createRequestTypes(
  `${prefix}/INSERT_ABSTRACT_SUBDIVISION_FILE`,
);

export const insertAbstractSubdivisionFile = makeApiActionCreatorV3(
  api.insertAbstractSubdivisionFile,
  INSERT_ABSTRACT_SUBDIVISION_FILE[START],
  INSERT_ABSTRACT_SUBDIVISION_FILE[SUCCESS],
  INSERT_ABSTRACT_SUBDIVISION_FILE[ERROR],
);

export const DELETE_ABSTRACT_SUBDIVISION_FILE = createRequestTypes(
  `${prefix}/DELETE_ABSTRACT_SUBDIVISION_FILE`,
);

export const deleteAbstractSubdivisionFile = makeApiActionCreatorV3(
  api.deleteAbstractSubdivisionFile,
  DELETE_ABSTRACT_SUBDIVISION_FILE[START],
  DELETE_ABSTRACT_SUBDIVISION_FILE[SUCCESS],
  DELETE_ABSTRACT_SUBDIVISION_FILE[ERROR],
);

export const DOWNLOAD_ABSTRACT_SUBDIVISION_FILE = createRequestTypes(
  `${prefix}/DOWNLOAD_ABSTRACT_SUBDIVISION_FILE`,
);

export const downloadAbstractSubdivisionFile = makeApiActionCreatorV3(
  api.downloadAbstractSubdivisionFile,
  DOWNLOAD_ABSTRACT_SUBDIVISION_FILE[START],
  DOWNLOAD_ABSTRACT_SUBDIVISION_FILE[SUCCESS],
  DOWNLOAD_ABSTRACT_SUBDIVISION_FILE[ERROR],
);

export const UPDATE_ABSTRACT_SUBDIVISION_FILE = createRequestTypes(
  `${prefix}/UPDATE_ABSTRACT_SUBDIVISION_FILE`,
);

export const updateAbstractSubdivisionFile = makeApiActionCreatorV3(
  api.updateAbstractSubdivisionFile,
  UPDATE_ABSTRACT_SUBDIVISION_FILE[START],
  UPDATE_ABSTRACT_SUBDIVISION_FILE[SUCCESS],
  UPDATE_ABSTRACT_SUBDIVISION_FILE[ERROR],
);

export const FETCH_ABSTRACT_SUBDIVISION_DETAILS = createRequestTypes(
  `${prefix}/FETCH_ABSTRACT_SUBDIVISION_DETAILS`,
);

export const fetchAbstractSubdivisionDetails = makeApiActionCreatorV3(
  api.fetchAbstractSubdivisionDetails,
  FETCH_ABSTRACT_SUBDIVISION_DETAILS[START],
  FETCH_ABSTRACT_SUBDIVISION_DETAILS[SUCCESS],
  FETCH_ABSTRACT_SUBDIVISION_DETAILS[ERROR],
);

export const DELETE_ABSTRACT_SUBDIVISION_DETAILS = createRequestTypes(
  `${prefix}/DELETE_ABSTRACT_SUBDIVISION_DETAILS`,
);

export const deleteAbstractSubdivisionDetail = makeApiActionCreatorV3(
  api.deleteAbstractSubdivisionDetail,
  DELETE_ABSTRACT_SUBDIVISION_DETAILS[START],
  DELETE_ABSTRACT_SUBDIVISION_DETAILS[SUCCESS],
  DELETE_ABSTRACT_SUBDIVISION_DETAILS[ERROR],
);

export const INSERT_ABSTRACT_SUBDIVISION_DETAIL = createRequestTypes(
  `${prefix}/INSERT_ABSTRACT_SUBDIVISION_DETAIL`,
);

export const insertAbstractSubdivisionDetail = makeApiActionCreatorV3(
  api.insertAbstractSubdivisionDetail,
  INSERT_ABSTRACT_SUBDIVISION_DETAIL[START],
  INSERT_ABSTRACT_SUBDIVISION_DETAIL[SUCCESS],
  INSERT_ABSTRACT_SUBDIVISION_DETAIL[ERROR],
);

export const FETCH_ABSTRACT_SUBDIVISION_DETAIL = createRequestTypes(
  `${prefix}/FETCH_ABSTRACT_SUBDIVISION_DETAIL`,
);

export const fetchAbstractSubdivisionDetail = makeApiActionCreatorV3(
  api.fetchAbstractSubdivisionDetail,
  FETCH_ABSTRACT_SUBDIVISION_DETAIL[START],
  FETCH_ABSTRACT_SUBDIVISION_DETAIL[SUCCESS],
  FETCH_ABSTRACT_SUBDIVISION_DETAIL[ERROR],
);

export const UPDATE_ABSTRACT_SUBDIVISION_DETAIL = createRequestTypes(
  `${prefix}/UPDATE_ABSTRACT_SUBDIVISION_DETAIL`,
);

export const updateAbstractSubdivisionDetail = makeApiActionCreatorV3(
  api.updateAbstractSubdivisionDetail,
  UPDATE_ABSTRACT_SUBDIVISION_DETAIL[START],
  UPDATE_ABSTRACT_SUBDIVISION_DETAIL[SUCCESS],
  UPDATE_ABSTRACT_SUBDIVISION_DETAIL[ERROR],
);

export const FETCH_ABSTRACT_SUBDIVISION_PLAT_TYPES = createRequestTypes(
  `${prefix}/FETCH_ABSTRACT_SUBDIVISION_PLAT_TYPES`,
);

export const fetchAbstractSubdivisionPlatTypes = makeApiActionCreatorV3(
  api.fetchAbstractSubdivisionPlatTypes,
  FETCH_ABSTRACT_SUBDIVISION_PLAT_TYPES[START],
  FETCH_ABSTRACT_SUBDIVISION_PLAT_TYPES[SUCCESS],
  FETCH_ABSTRACT_SUBDIVISION_PLAT_TYPES[ERROR],
);

export const INSERT_ABSTRACT_SUBDIVISION_PLAT = createRequestTypes(
  `${prefix}/INSERT_ABSTRACT_SUBDIVISION_PLAT`,
);

export const insertAbstractSubdivisionPlat = makeApiActionCreatorV3(
  api.insertAbstractSubdivisionPlat,
  INSERT_ABSTRACT_SUBDIVISION_PLAT[START],
  INSERT_ABSTRACT_SUBDIVISION_PLAT[SUCCESS],
  INSERT_ABSTRACT_SUBDIVISION_PLAT[ERROR],
);

export const INSERT_ABSTRACT_SUBDIVISION_DETAIL_FILE = createRequestTypes(
  `${prefix}/INSERT_ABSTRACT_SUBDIVISION_DETAIL_FILE`,
);

export const insertAbstractSubdivisionDetailFile = makeApiActionCreatorV3(
  api.insertAbstractSubdivisionDetailFile,
  INSERT_ABSTRACT_SUBDIVISION_DETAIL_FILE[START],
  INSERT_ABSTRACT_SUBDIVISION_DETAIL_FILE[SUCCESS],
  INSERT_ABSTRACT_SUBDIVISION_DETAIL_FILE[ERROR],
);

export const DELETE_ABSTRACT_SUBDIVISION_DETAIL_FILE = createRequestTypes(
  `${prefix}/DELETE_ABSTRACT_SUBDIVISION_DETAIL_FILE`,
);

export const deleteAbstractSubdivisionDetailFile = makeApiActionCreatorV3(
  api.deleteAbstractSubdivisionDetailFile,
  DELETE_ABSTRACT_SUBDIVISION_DETAIL_FILE[START],
  DELETE_ABSTRACT_SUBDIVISION_DETAIL_FILE[SUCCESS],
  DELETE_ABSTRACT_SUBDIVISION_DETAIL_FILE[ERROR],
);

export const DOWNLOAD_ABSTRACT_SUBDIVISION_DETAIL_FILE = createRequestTypes(
  `${prefix}/DOWNLOAD_ABSTRACT_SUBDIVISION_DETAIL_FILE`,
);

export const downloadAbstractSubdivisionDetailFile = makeApiActionCreatorV3(
  api.downloadAbstractSubdivisionDetailFile,
  DOWNLOAD_ABSTRACT_SUBDIVISION_DETAIL_FILE[START],
  DOWNLOAD_ABSTRACT_SUBDIVISION_DETAIL_FILE[SUCCESS],
  DOWNLOAD_ABSTRACT_SUBDIVISION_DETAIL_FILE[ERROR],
);

export const UPDATE_ABSTRACT_SUBDIVISION_DETAIL_FILE = createRequestTypes(
  `${prefix}/UPDATE_ABSTRACT_SUBDIVISION_DETAIL_FILE`,
);

export const updateAbstractSubdivisionDetailFile = makeApiActionCreatorV3(
  api.updateAbstractSubdivisionDetailFile,
  UPDATE_ABSTRACT_SUBDIVISION_DETAIL_FILE[START],
  UPDATE_ABSTRACT_SUBDIVISION_DETAIL_FILE[SUCCESS],
  UPDATE_ABSTRACT_SUBDIVISION_DETAIL_FILE[ERROR],
);

export const FETCH_ABSTRACT_SUBDIVISION_PLAT = createRequestTypes(
  `${prefix}/FETCH_ABSTRACT_SUBDIVISION_PLAT`,
);

export const fetchAbstractSubdivisionPlat = makeApiActionCreatorV3(
  api.fetchAbstractSubdivisionPlat,
  FETCH_ABSTRACT_SUBDIVISION_PLAT[START],
  FETCH_ABSTRACT_SUBDIVISION_PLAT[SUCCESS],
  FETCH_ABSTRACT_SUBDIVISION_PLAT[ERROR],
);

export const UPDATE_ABSTRACT_SUBDIVISION_PLAT = createRequestTypes(
  `${prefix}/UPDATE_ABSTRACT_SUBDIVISION_PLAT`,
);

export const updateAbstractSubdivisionPlat = makeApiActionCreatorV3(
  api.updateAbstractSubdivisionPlat,
  UPDATE_ABSTRACT_SUBDIVISION_PLAT[START],
  UPDATE_ABSTRACT_SUBDIVISION_PLAT[SUCCESS],
  UPDATE_ABSTRACT_SUBDIVISION_PLAT[ERROR],
);

export const INSERT_ABSTRACT_SUBDIVISION_PLAT_FILE = createRequestTypes(
  `${prefix}/INSERT_ABSTRACT_SUBDIVISION_PLAT_FILE`,
);

export const insertAbstractSubdivisionPlatFile = makeApiActionCreatorV3(
  api.insertAbstractSubdivisionPlatFile,
  INSERT_ABSTRACT_SUBDIVISION_PLAT_FILE[START],
  INSERT_ABSTRACT_SUBDIVISION_PLAT_FILE[SUCCESS],
  INSERT_ABSTRACT_SUBDIVISION_PLAT_FILE[ERROR],
);

export const DELETE_ABSTRACT_SUBDIVISION_PLAT_FILE = createRequestTypes(
  `${prefix}/DELETE_ABSTRACT_SUBDIVISION_PLAT_FILE`,
);

export const deleteAbstractSubdivisionPlatFile = makeApiActionCreatorV3(
  api.deleteAbstractSubdivisionPlatFile,
  DELETE_ABSTRACT_SUBDIVISION_PLAT_FILE[START],
  DELETE_ABSTRACT_SUBDIVISION_PLAT_FILE[SUCCESS],
  DELETE_ABSTRACT_SUBDIVISION_PLAT_FILE[ERROR],
);

export const DOWNLOAD_ABSTRACT_SUBDIVISION_PLAT_FILE = createRequestTypes(
  `${prefix}/DOWNLOAD_ABSTRACT_SUBDIVISION_PLAT_FILE`,
);

export const downloadAbstractSubdivisionPlatFile = makeApiActionCreatorV3(
  api.downloadAbstractSubdivisionPlatFile,
  DOWNLOAD_ABSTRACT_SUBDIVISION_PLAT_FILE[START],
  DOWNLOAD_ABSTRACT_SUBDIVISION_PLAT_FILE[SUCCESS],
  DOWNLOAD_ABSTRACT_SUBDIVISION_PLAT_FILE[ERROR],
);

export const UPDATE_ABSTRACT_SUBDIVISION_PLAT_FILE = createRequestTypes(
  `${prefix}/UPDATE_ABSTRACT_SUBDIVISION_PLAT_FILE`,
);

export const updateAbstractSubdivisionPlatFile = makeApiActionCreatorV3(
  api.updateAbstractSubdivisionPlatFile,
  UPDATE_ABSTRACT_SUBDIVISION_PLAT_FILE[START],
  UPDATE_ABSTRACT_SUBDIVISION_PLAT_FILE[SUCCESS],
  UPDATE_ABSTRACT_SUBDIVISION_PLAT_FILE[ERROR],
);

export const UPDATE_ABSTRACT_SUBDIVISION_TAGS = createRequestTypes(
  `${prefix}/UPDATE_ABSTRACT_SUBDIVISION_TAGS`,
);

export const updateAbstractSubdivisionTags = makeApiActionCreatorV3(
  api.updateAbstractSubdivisionTags,
  UPDATE_ABSTRACT_SUBDIVISION_TAGS[START],
  UPDATE_ABSTRACT_SUBDIVISION_TAGS[SUCCESS],
  UPDATE_ABSTRACT_SUBDIVISION_TAGS[ERROR],
);

export const CHANGE_SORT_MODEL = `${prefix}/CHANGE_SORT_MODEL`;

export const changeSortModel = model => ({
  type: CHANGE_SORT_MODEL,
  payload: model,
});

export const DELETE_ABSTRACT_SUBDIVISION_PLAT = createRequestTypes(
  `${prefix}/DELETE_ABSTRACT_SUBDIVISION_PLAT`,
);

export const deleteAbstractSubdivisionPlat = makeApiActionCreatorV3(
  api.deleteAbstractSubdivisionPlat,
  DELETE_ABSTRACT_SUBDIVISION_PLAT[START],
  DELETE_ABSTRACT_SUBDIVISION_PLAT[SUCCESS],
  DELETE_ABSTRACT_SUBDIVISION_PLAT[ERROR],
);